// extracted by mini-css-extract-plugin
module.exports = {"clickable":"LLMDialogs_clickable__BnsJF","flex":"LLMDialogs_flex__3sfj_","flexContainer":"LLMDialogs_flexContainer__2nC5t","flexTitle":"LLMDialogs_flexTitle__2LSwk"};